import { mapState } from 'pinia';
import { auth } from 'src/store/auth';
import { personalize } from 'src/utils/TextUtils';

export default {

  computed: {
    ...mapState(auth, ['currentClient', 'currentClientFirstName']),

  },

  methods: {

    personalize(text, client) {
      const clientToUse = client || this.currentClient;

      // Refactored to Composition API:
      return personalize(
        text,
        clientToUse?.firstName || clientToUse?.clientName,
        clientToUse?.gender,
      );
    },
  },
};
